import React, { Suspense } from 'react';
import Link from 'gatsby-link';
import Button from '../ui/button';
import LazyImage from '../ui/lazyImage';
import VideoBackground from './videoBackground';
import mouseTranslate from '../global/mouseTranslate';
import * as style from './gridCallout.module.scss';
import translations from '../../utils/translations';
import { camelize } from '../../utils/helpers';
import Loading from '../global/loading';

const imgRanges = {
  x: [-30, 30],
  y: [-30, 30],
};
const textRanges = {
  x: [-50, 50],
  y: [-50, 50],
};

const DisplayText = props => {
  const displayText = (
    <div>
      <span className={`f-label ${style.indicatorlabel}`}>
        {props.label === 'Interactive Feature' ? translations.t('Interactive') : props.label}
      </span>
      <span className={style.indicatorLine} />
      <div className={style.calloutTitle}>
        <h3 dangerouslySetInnerHTML={{ __html: props.title }} />
      </div>
    </div>
  );
  return props.path ? (
    <Link to={props.path} className={`${style.link}`}>
      {displayText}
    </Link>
  ) : (
    displayText
  );
};

const GridCallout = props => {
  const isSSR = typeof window === "undefined";
  return (
    <>
    {!isSSR && (
    <Suspense fallback={<Loading/>}>
      <div className={`${style.gridCallout} container-component cf`}>
        <div
          className={`${style.calloutInner} ${style[props.componentStyle]} ${style[camelize(props.imageAlignmentType)]
            } ${style[props.imageWidthType]}`}
        >
          <div
            className={`typeFonts1 ${style.calloutText} ${style[props.textVerticalAlign]
              }`}
          >
            <div
              style={{
                transform: props.textTransform,
              }}
              className={style.textTransformer}
            >
              <div className="fadeInBlur reveal">
                {props.componentStyle === 'withText' ? (
                  <div>
                    <span className={`f-label ${style.indicatorlabel}`}>
                      {props.label === 'Interactive Feature'
                        ? translations.t('Interactive')
                        : props.label}
                    </span>
                    <div className={style.calloutTitle}>
                      <h2 dangerouslySetInnerHTML={{ __html: props.title }} />
                    </div>
                    {props.text && (
                      <div dangerouslySetInnerHTML={{ __html: props.text }} />
                    )}
                    {props.cta_link && (
                      <div className={style.calloutButton}>
                        <Button
                          color={props.cta_color}
                          to={props.cta_link.url}
                          text={props.cta_link.title}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  <DisplayText {...props} />
                )}
              </div>
            </div>
          </div>
          <figure
            className={`${style.calloutImage}`}
            style={{
              transform: props.imgTransform,
            }}
          >
            <div className="reveal fadeInUp">
              {props.path ? (
                <Link className={style.imageLink} to={props.path}>
                  <div className={style.imgWrap}>
                    {props.videoSrc ? (
                      <div className={style.videoWrapper}>
                        <VideoBackground
                          videoStyle="normal"
                          src={props.videoSrc}
                        />
                      </div>
                    ) : (
                      <LazyImage
                        // src={props.imgSizePortrait}
                        src={props.imgSrc}
                        alt={props.imgAltText}
                        hasRevealer={props.hasRevealer}
                        revealed={props.revealed}
                        width={props.imgDimensions.width}
                        height={props.imgDimensions.height}
                        opacity={0.5}
                        fitSize
                      />
                    )}
                  </div>
                </Link>
              ) : (
                <div className={style.imgWrap}>
                  {props.videoSrc ? (
                    <div className={style.videoWrapper}>
                      <VideoBackground videoStyle="cover" src={props.videoSrc} />
                    </div>
                  ) : (
                    <LazyImage
                      // src={props.imgSizePortrait}
                      src={props.imgSrc}
                      alt={props.imgAltText}
                      hasRevealer={props.hasRevealer}
                      revealed={props.revealed}
                      width={props.imgDimensions.width}
                      height={props.imgDimensions.height}
                      opacity={0.5}
                      fitSize
                    />
                  )}
                </div>
              )}
            </div>
          </figure>
        </div>
      </div>
    </Suspense>
    )}
    </>
  );
};

export default mouseTranslate(GridCallout, imgRanges, textRanges);
